<template>
<div style="height: 100%">
  <div style="height: 40px;width: 100%;margin-top: -20px;padding: 0 30px">
    <div :class="item.index === indexActive ? 'select-active' : 'no-select'" v-for="item in tabs" :key="item.index" @click="selectTab(item)">
      <span>{{item.name}}</span>
    </div>
  </div>
  <div v-if="indexActive === 0" style="height: calc(100% - 20px)">
    <map-location :handleMapObj="trackDetailsObj"></map-location>
  </div>
  <div v-if="indexActive === 1" style="height: calc(100% - 20px)">
    <history-map-track :trackObj="trackDetailsObj"></history-map-track>
  </div>
  <div v-if="indexActive === 2" style="height: calc(100% - 50px)">
<!--    <electronic-fence></electronic-fence>-->
    <device-ecircle :trackObj="trackDetailsObj"></device-ecircle>
  </div>
</div>
</template>

<script>
import mapLocation from '../../handlealarm/childComponents/mapLocation'
import historyMapTrack from './historyMapTrack.vue'
import electronicFence from '../../oldPersonHome/components/electronicFence'
import deviceEcircle from './deviceEcircle.vue'
export default {
  name: 'trackDetails',
  components: {mapLocation, historyMapTrack, electronicFence, deviceEcircle},
  props: {
    trackDetailsObj: {
      type: Object,
      default: null
    }
  },
  data () {
    return {
      tabs: [
        {index: 0, name: '当前位置'},
        {index: 1, name: '历史轨迹'},
        {index: 2, name: '围栏设置'}
      ],
      indexActive: 0
    }
  },
  created () {
    // console.log(this.trackDetailsObj)
  },
  mounted () {
  },
  methods: {
    selectTab (item) {
      this.indexActive = item.index
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/datamanagement/deviceComponents/trackDetails.vue